"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the sign of the given quad-precision floating point number.
 * * prefer inlining this - it is really only here for reference
 */
function qSign([q, Q]) {
    return Q;
}
exports.qSign = qSign;
//# sourceMappingURL=q-sign.js.map